import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/iblVoxelGrid.vertex.js
var name, shader, iblVoxelGridVertexShaderWGSL;
var init_iblVoxelGrid_vertex = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/iblVoxelGrid.vertex.js"() {
    init_shaderStore();
    name = "iblVoxelGridVertexShader";
    shader = `attribute position: vec3f;attribute normal: vec3f;varying vNormalizedPosition: vec3f;uniform world: mat4x4f;uniform invWorldScale: mat4x4f;uniform viewMatrix: mat4x4f;@vertex
fn main(input : VertexInputs)->FragmentInputs {vertexOutputs.position=uniforms.viewMatrix*uniforms.invWorldScale*uniforms.world* vec4f(input.position,1.);vertexOutputs.vNormalizedPosition=vertexOutputs.position.xyz*0.5+0.5;
#ifdef IS_NDC_HALF_ZRANGE
vertexOutputs.position=vec4f(vertexOutputs.position.x,vertexOutputs.position.y,vertexOutputs.position.z*0.5+0.5,vertexOutputs.position.w);
#endif
}`;
    ShaderStore.ShadersStoreWGSL[name] = shader;
    iblVoxelGridVertexShaderWGSL = { name, shader };
  }
});

export {
  iblVoxelGridVertexShaderWGSL,
  init_iblVoxelGrid_vertex
};
